import BuildCircleIcon from "@mui/icons-material/BuildCircle";
import ElectricRickshawIcon from "@mui/icons-material/ElectricRickshaw";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import SquareFootIcon from "@mui/icons-material/SquareFoot";
import WorkspacePremiumRoundedIcon from "@mui/icons-material/WorkspacePremiumRounded";
import PowerIcon from '@mui/icons-material/Power';
import OfflineBoltIcon from '@mui/icons-material/OfflineBolt';
import HealthAndSafetyIcon from '@mui/icons-material/HealthAndSafety';
import LivingIcon from '@mui/icons-material/Living';

export const vehiclePromiseList = {
  treoZor: [
    {
      id: 1,
      icon: <ElectricRickshawIcon />,
      question: "Performance",
      // answer:
      //   "We offer a wide range of electric cargo vehicles from leading manufacturers, including Mahindra, Piaggio, E-trio, Euler and OSM.",

      tableData: [
        { feature: "Max torque", details: "42nm" },
        { feature: "Max Speed", details: "55kmph" },
        { feature: "Load", details: "550 kgs" },
        { feature: "Range", details: "80 kms" },
        { feature: "Load body size", details: "120 cu.ft." },
        { feature: "GVW", details: "975 kgs" },
      ],
    },

    {
      id: 2,
      icon: <SquareFootIcon />,
      question: "Dimensions",
      // answer:
      //   "We own a team of experts who can help businesses and individuals choose the right electric commercial vehicle for their needs.",
      tableData: [
        { feature: "Length", details: "10.17 ft" },
        { feature: "Width", details: "4.79 ft" },
        { feature: "Height", details: "5.78 ft" },
        { feature: "Wheelbase", details: "7.27 ft" },
        { feature: "Ground clearance", details: "0.40 ft" },
      ],
    },

    {
      id: 3,
      icon: <WorkspacePremiumRoundedIcon />,
      question: "Brakes & Suspensions",
      // answer:
      //   "We offer financing options to make it easy to purchase electric goods vehicles.",
      tableData: [
        { feature: "Brakes", details: "Hydraulic Brakes" },
        {
          feature: "Front suspension",
          details: "Helical Spring + Damper Hydraulic Shock Absorber",
        },
        { feature: "Rear suspension", details: "Rigid axle with leaf spring" },
        { feature: "Parking brakes", details: "Available" },
      ],
    },

    {
      id: 4,
      icon: <BuildCircleIcon />,
      question: "Charging",
      // answer:
      //   "We provide maintenance and repair services to keep electric load vehicles running smoothly.",
      tableData: [
        { feature: "Charging time", details: "3h 50 min" },
        { feature: "Battery capacity", details: "7.37 kWh" },
        { feature: "Type of battery", details: "Lithium-ion, 48 V" },
      ],
    },
    {
      id: 5,
      icon: <LocalShippingIcon />,
      question: "Body",
      // answer:
      //   "We provide free doorstep test drives for the vehicle of choice so that an informed decision can be taken.",

      tableData: [
        { feature: "Chassis type", details: "Chassis with Cabin" },
        { feature: "Body options", details: "Flatbed, Pick-up, and Full body" },
        { feature: "Cabin type", details: "Day Cabin" },
      ],
    },

    {
      id: 6,
      icon: <ManageAccountsIcon />,
      question: "Additional Features",
      // answer:
      //   "We provide free doorstep test drives for the vehicle of choice so that an informed decision can be taken.",
      tableData: [
        { feature: "GPS", details: "Yes" },
        { feature: "Seating Capacity", details: "Driver Only" },
        { feature: "Gradeability", details: "12.70%" },
        { feature: "Driver information display", details: "Yes" },
        { feature: "Electric motor", details: "Advanced IP67 rated" },
      ],
    },
  ],

  zorGrand: [
    {
      id: 1,
      icon: <ElectricRickshawIcon />,
      question: "Performance",
      // answer:
      //   "We offer a wide range of electric cargo vehicles from leading manufacturers, including Mahindra, Piaggio, E-trio, Euler and OSM.",

      tableData: [
        { feature: "Max torque", details: "50 Nm" },
        { feature: "Speed", details: "50 kmph" },
        { feature: "Tyres", details: "-" },
        { feature: "Kerb weight", details: "598 kgs" },
        { feature: "Range", details: "up to 85 kms" },
        { feature: "Load body size", details: "170 cu.ft." },
        { feature: "GVW", details: "998 kgs" },
      ],
    },

    {
      id: 2,
      icon: <SquareFootIcon />,
      question: "Dimensions",
      // answer:
      //   "We own a team of experts who can help businesses and individuals choose the right electric commercial vehicle for their needs.",
      tableData: [
        { feature: "Length", details: "11.15 ft" },
        { feature: "Width", details: "5.22 ft" },
        { feature: "Height", details: "8.17 ft" },
        { feature: "Wheelbase", details: "0.59 ft" },
        { feature: "Ground clearance", details: "7.22 ft" },
      ],
    },

    {
      id: 3,
      icon: <WorkspacePremiumRoundedIcon />,
      question: "Brakes & Suspensions",
      // answer:
      //   "We offer financing options to make it easy to purchase electric goods vehicles.",
      tableData: [
        { feature: "Brakes", details: "Hydraulic Drum" },
        {
          feature: "Front suspension",
          details: "Helical Spring & Hydraulic Shock absorber",
        },
        {
          feature: "Rear suspension",
          details: "Rubber Spring & Hydraulic Shock absorber",
        },
        { feature: "Parking brake type", details: "Mechanical Lever Type" },
      ],
    },

    {
      id: 4,
      icon: <BuildCircleIcon />,
      question: "Charging",
      // answer:
      //   "We provide maintenance and repair services to keep electric load vehicles running smoothly.",
      tableData: [
        { feature: "Charging time", details: "4 Hours" },
        { feature: "Battery capacity", details: "48 v" },
        {
          feature: "Type of battery",
          details: "IP67 certified li-ion battery",
        },
      ],
    },
    {
      id: 5,
      icon: <LocalShippingIcon />,
      question: "Body",
      // answer:
      //   "We provide free doorstep test drives for the vehicle of choice so that an informed decision can be taken.",

      tableData: [
        { feature: "Chassis Type", details: "Chassis with Cabin" },
        { feature: "Body Option", details: "Delivery Van, Pick up" },
        { feature: "Cabin Type", details: "Day Cabin" },
      ],
    },

    {
      id: 6,
      icon: <ManageAccountsIcon />,
      question: "Additional Features",
      // answer:
      //   "We provide free doorstep test drives for the vehicle of choice so that an informed decision can be taken.",
      tableData: [
        { feature: "Cruise Control", details: "Yes" },
        { feature: "GPS", details: "Yes" },
        { feature: "Seating Capacity", details: "Driver Only" },
        { feature: "Tubeless tyres", details: "No" },
        { feature: "Gradeability", details: "11.5 %" },
        { feature: "Driver information display", details: "Yes" },
      ],
    },
  ],

  piaggioFX: [
    {
      id: 1,
      icon: <ElectricRickshawIcon />,
      question: "Performance",
      // answer:
      //   "We offer a wide range of electric cargo vehicles from leading manufacturers, including Mahindra, Piaggio, E-trio, Euler and OSM.",

      tableData: [
        { feature: "Max torque", details: "45 Nm" },
        { feature: "Speed", details: "45 kmph" },
        { feature: "Tyres", details: "3" },
        { feature: "Kerb weight", details: "480 kgs" },
        { feature: "Range", details: "80 kms" },
        { feature: "Load Capacity", details: "550 Kgs" },
        { feature: "GVW", details: "975 Kgs" },
      ],
    },

    {
      id: 2,
      icon: <SquareFootIcon />,
      question: "Dimensions",
      // answer:
      //   "We own a team of experts who can help businesses and individuals choose the right electric commercial vehicle for their needs.",
      tableData: [
        { feature: "Length", details: "10.88 ft" },
        { feature: "Width", details: "4.89 ft" },
        { feature: "Height", details: "5.81 ft" },
        { feature: "Wheelbase", details: "6.89 ft" },
        { feature: "Ground clearance", details: "0.72 ft" },
      ],
    },

    {
      id: 3,
      icon: <WorkspacePremiumRoundedIcon />,
      question: "Brakes & Suspensions",
      // answer:
      //   "We offer financing options to make it easy to purchase electric goods vehicles.",
      tableData: [
        { feature: "Brakes", details: "Hydraulically actuated drum brakes" },
        {
          feature: "Front suspension",
          details: "Helical spring with dampener",
        },
        { feature: "Rear suspension", details: "Rubber spring with dampener" },
      ],
    },

    {
      id: 4,
      icon: <BuildCircleIcon />,
      question: "Charging",
      // answer:
      //   "We provide maintenance and repair services to keep electric load vehicles running smoothly.",
      tableData: [
        { feature: "Charging time", details: "3 hours 30 mins" },
        { feature: "Battery capacity", details: "9.55 kWh" },
        { feature: "Type of battery", details: "51.2 V lithium-ion" },
      ],
    },
    {
      id: 5,
      icon: <LocalShippingIcon />,
      question: "Body",
      // answer:
      //   "We provide free doorstep test drives for the vehicle of choice so that an informed decision can be taken.",

      tableData: [
        { feature: "Body option", details: "Flatbed, Pick-up, Full Body" },
        { feature: "Chassis Type", details: "Chassis with Cabin" },
      ],
    },

    {
      id: 6,
      icon: <ManageAccountsIcon />,
      question: "Additional Features",
      // answer:
      //   "We provide free doorstep test drives for the vehicle of choice so that an informed decision can be taken.",
      tableData: [
        { feature: "Cruise Control", details: "No" },
        { feature: "GPS", details: "Yes" },
        { feature: "Seating Capacity", details: "Driver" },
        { feature: "Gradability", details: "17%" },
        { feature: "Driver information display", details: "Available" },
        { feature: "Fog Lights", details: "Available" },
        { feature: "Advanced Telematics 2.0", details: "Available" },
        { feature: "iConnect app connectivity", details: "Available" },
      ],
    },
  ],
  piaggioFXMax: [
    {
      id: 1,
      icon: <ElectricRickshawIcon />,
      question: "Performance",

      tableData: [
        { feature: "Max torque", details: "45 Nm" },
        { feature: "Speed", details: "50 kmph" },
        { feature: "Tyres", details: "3" },
        { feature: "Kerb weight", details: "975 kgs" },
        { feature: "Range", details: "90 kms" },
        { feature: "Load Capacity", details: "550 kgs" },
        { feature: "GVW", details: "505 kgs" },
      ],
    },

    {
      id: 2,
      icon: <SquareFootIcon />,
      question: "Dimensions",
      tableData: [
        { feature: "Length", details: "10.88 ft." },
        { feature: "Width", details: "4.89 ft." },
        { feature: "Height", details: "5.81 ft." },
        { feature: "Wheelbase", details: "6.89 ft." },
        { feature: "Ground clearance", details: "0.72 ft." },
        { feature: "Container Volume", details: "158 cu. ft." },
      ],
    },

    {
      id: 3,
      icon: <WorkspacePremiumRoundedIcon />,
      question: "Brakes & Suspensions",
      tableData: [
        {
          feature: "Brakes",
          details:
            "Drum Brake Hydraulically Actuated Internal Expanding Shoe Type",
        },
        {
          feature: "Front suspension",
          details: "Helical spring with dampener",
        },
        {
          feature: "Rear suspension",
          details: "Rubber Spring with damper",
        },
        {
          feature: "Parking brake type",
          details: "Hydraulic",
        },
      ],
    },

    {
      id: 4,
      icon: <BuildCircleIcon />,
      question: "Charging",
      tableData: [
        { feature: "Charging time", details: "3 hours 45 mins" },
        { feature: "Battery capacity", details: "51.2 V Li-ion" },
        { feature: "Type of battery", details: "IP67 certified Li-ion" },
      ],
    },
    {
      id: 5,
      icon: <LocalShippingIcon />,
      question: "Body",

      tableData: [
        { feature: "Chassis type", details: "Chassis with Cabin" },
        { feature: "Body options", details: "Flatbed, Pick-up, and Full body" },
        { feature: "Cabin type", details: "Day Cabin" },
      ],
    },

    {
      id: 6,
      icon: <ManageAccountsIcon />,
      question: "Additional Features",
      tableData: [
        { feature: "GPS", details: "Yes" },
        { feature: "Seating Capacity", details: "Driver only" },
        { feature: "Tubeless tyres", details: "No" },
        { feature: "Gradability", details: "19%" },
        { feature: "Driver information display", details: "Yes" },
        {
          feature: "Advanced Telematics 2.0",
          details: "iConnect app connectivity",
        },
      ],
    },
  ],

  greavesEltra: [
    {
      id: 1,
      icon: <ElectricRickshawIcon />,
      question: "Performance",

      tableData: [
        { feature: "Max torque", details: "49 Nm" },
        {
          feature: "Speed",
          details: "50 kmph",
        },
        {
          feature: "Tyres",
          details: "3",
        },
        {
          feature: "Kerb weight",
          details: "996 kgs",
        },
        {
          feature: "GVW",
          details: "468 kgs",
        },
        {
          feature: "Range",
          details: "105 kms",
        },
        {
          feature: "Load Capacity",
          details: "530 kgs",
        },
      ],
    },

    {
      id: 2,
      icon: <SquareFootIcon />,
      question: "Dimensions",
      tableData: [
        {
          feature: "Length",
          details: "10.49 ft",
        },
        {
          feature: "Width",
          details: "4.89 ft",
        },
        {
          feature: "Height",
          details: "5.66 ft",
        },
        {
          feature: "Wheelbase",
          details: "6.89 ft",
        },
        {
          feature: "Ground clearance",
          details: "0.59 ft",
        },
        {
          feature: "Container Volume",
          details: "147 cu. ft.",
        },
      ],
    },

    {
      id: 3,
      icon: <WorkspacePremiumRoundedIcon />,
      question: "Brakes & Suspensions",
      tableData: [
        {
          feature: "Brakes",
          details: "Hydraulic Drum brakes",
        },
        {
          feature: "Front suspension",
          details: "Helical spring with Dampener",
        },
        {
          feature: "Rear suspension",
          details: "Rubber spring with dampener",
        },
        {
          feature: "Parking brake type",
          details: "Hydraulic",
        },
      ],
    },

    {
      id: 4,
      icon: <BuildCircleIcon />,
      question: "Charging",
      tableData: [
        {
          feature: "Charging time",
          details: "5-6 hrs",
        },
        {
          feature: "Battery capacity",
          details: "10.8 kWh, 51.2 v li-ion",
        },
        {
          feature: "Type of battery",
          details: "IP67 LFP battery",
        },
      ],
    },
    {
      id: 5,
      icon: <LocalShippingIcon />,
      question: "Body",

      tableData: [
        {
          feature: "Chassis type",
          details: "Chassis with Cabin",
        },
        {
          feature: "Body option",
          details: "Full Body, Pick-up and flatbed",
        },
        {
          feature: "Cabin type",
          details: "Day Cabin",
        },
        {
          feature: "Driver Cabin",
          details: "Closed",
        },
      ],
    },

    {
      id: 6,
      icon: <ManageAccountsIcon />,
      question: "Additional Features",
      tableData: [
        {
          feature: "GPS",
          details: "Yes",
        },
        {
          feature: "Transmission Type",
          details: "Independent Drive",
        },
        {
          feature: "Seating Capacity",
          details: "Driver only",
        },
        {
          feature: "Hill Hold Assist",
          details: "Yes",
        },
        {
          feature: "Gradability",
          details: "21.3%",
        },
        {
          feature: "Driver information display",
          details: "Yes",
        },
        {
          feature: "Cloud based e-mobility telematics",
          details: "Yes",
        },
      ],
    },
  ],

  touroMax: [
    {
      id: 1,
      icon: <ElectricRickshawIcon />,
      question: "Performance",

      tableData: [
        {
          feature: "Max torque",
          details: "63 Nm",
        },
        {
          feature: "Speed",
          details: "50 kmph",
        },
        {
          feature: "Tyres",
          details: "3",
        },
        {
          feature: "Kerb weight",
          details: "950 kgs",
        },
        {
          feature: "Range",
          details: "100 kms",
        },
        {
          feature: "Load Capacity",
          details: "550 kgs",
        },
        {
          feature: "GVW",
          details: "505 kgs",
        },
      ],
    },

    {
      id: 2,
      icon: <SquareFootIcon />,
      question: "Dimensions",
      tableData: [
        {
          feature: "Length",
          details: "10.30 ft.",
        },
        {
          feature: "Width",
          details: "4.82 ft.",
        },
        {
          feature: "Height",
          details: "5.71 ft.",
        },
        {
          feature: "Wheelbase",
          details: "7.02 ft.",
        },
        {
          feature: "Ground clearance",
          details: "0.59 ft.",
        },
        {
          feature: "Container Volume",
          details: "135 cu. ft.",
        },
      ],
    },

    {
      id: 3,
      icon: <WorkspacePremiumRoundedIcon />,
      question: "Brakes & Suspensions",
      tableData: [
        {
          feature: "Brakes",
          details: "Drum Brake",
        },
        {
          feature: "Front suspension",
          details: "Coil Spring With Telescopic Shock Absorber",
        },
        {
          feature: "Rear suspension",
          details: "Rubber Boot With Telescopic Shock Absorber",
        },
        {
          feature: "Parking brake type",
          details: "Hydraulic",
        },
      ],
    },

    {
      id: 4,
      icon: <BuildCircleIcon />,
      question: "Charging",
      tableData: [
        {
          feature: "Charging time",
          details: "4 hours",
        },
        {
          feature: "Battery capacity",
          details: "10.8 kWh, 48v Li-ion",
        },
        {
          feature: "Type of battery",
          details: "IP65 certified Li-ion",
        },
      ],
    },
    {
      id: 5,
      icon: <LocalShippingIcon />,
      question: "Body",

      tableData: [
        {
          feature: "Chassis type",
          details: "Chassis with Cabin",
        },
        {
          feature: "Body option",
          details: "Full Body, Pick-up, and Flatbed",
        },
        {
          feature: "Cabin type",
          details: "Day Cabin",
        },
        {
          feature: "Front grille",
          details: "Bull-inspired signature front grille",
        },
      ],
    },

    {
      id: 6,
      icon: <ManageAccountsIcon />,
      question: "Additional Features",
      tableData: [
        {
          feature: "GPS",
          details: "Yes",
        },
        {
          feature: "Transmission Type",
          details: "Independent Drive",
        },
        {
          feature: "Seating Capacity",
          details: "Driver only",
        },
        {
          feature: "Tubeless Tires",
          details: "No",
        },
        {
          feature: "Gradability",
          details: "12.5%",
        },
        {
          feature: "Driver Information Display",
          details: "Yes",
        },
        {
          feature: "E-mobility Telematics",
          details: "Cloud-based e-mobility telematics",
        },
      ],
    },
  ],

  hiLoadDV: [
    {
      id: 1,
      icon: <ElectricRickshawIcon />,
      question: "Performance",
      tableData: [
        {
          feature: "Max torque",
          details: "88.55 Nm",
        },
        {
          feature: "Speed",
          details: "42 km/h",
        },
        {
          feature: "Tyres",
          details: "3",
        },
        {
          feature: "Kerb weight",
          details: "656 kgs",
        },
        {
          feature: "Range",
          details: "130 kms",
        },
        {
          feature: "Load Capacity",
          details: "688 kgs",
        },
        {
          feature: "GVW",
          details: "1413 kgs",
        },
      ],
    },

    {
      id: 2,
      icon: <SquareFootIcon />,
      question: "Dimensions",
      tableData: [
        {
          feature: "Length",
          details: "11.15 ft",
        },
        {
          feature: "Width",
          details: "4.79 ft",
        },
        {
          feature: "Height",
          details: "5.91 ft",
        },
        {
          feature: "Wheelbase",
          details: "7.22 ft",
        },
        {
          feature: "Ground clearance",
          details: "0.98 ft",
        },
      ],
    },

    {
      id: 3,
      icon: <WorkspacePremiumRoundedIcon />,
      question: "Brakes & Suspensions",
      tableData: [
        {
          feature: "Brakes",
          details: "Hydraulic | Single Pedal Actuation",
        },
        {
          feature: "Front suspension",
          details: "Hydraulic Shock absorber with helical Spring",
        },
        {
          feature: "Rear suspension",
          details:
            "Trailing arm with hydraulic Shock absorber with helical Spring",
        },
        {
          feature: "Parking brake type",
          details: "Mechanical lever",
        },
      ],
    },

    {
      id: 4,
      icon: <BuildCircleIcon />,
      question: "Charging",
      tableData: [
        {
          feature: "Charging time",
          details: "3-4 hours",
        },
        {
          feature: "Battery capacity",
          details: "13 kWh",
        },
        {
          feature: "Type of battery",
          details: "Liquid Cooled Li-ion Battery",
        },
      ],
    },

    {
      id: 5,
      icon: <LocalShippingIcon />,
      question: "Body",
      tableData: [
        {
          feature: "Chassis type",
          details: "Chassis with Cabin",
        },
        {
          feature: "Body option",
          details: "Flatbed, Full Body and Pick-up",
        },
        {
          feature: "Cabin type",
          details: "Day cabin",
        },
      ],
    },

    {
      id: 6,
      icon: <ManageAccountsIcon />,
      question: "Features",
      tableData: [
        {
          feature: "GPS",
          details: "Yes",
        },
        {
          feature: "Vehicle Tracking System",
          details: "Yes",
        },
        {
          feature: "Seating Capacity",
          details: "Driver Only",
        },
        {
          feature: "Gradeability",
          details: "21%",
        },
        {
          feature: "Driver information display",
          details: "Yes",
        },
        {
          feature: "Halogen Headlamps",
          details: "Yes",
        },
        {
          feature: "Wide Windscreen",
          details: "Yes",
        },
        {
          feature: "30% more tyre width",
          details: "Yes",
        },
      ],
    },
  ],
  neev: [
    {
      id: 1,
      icon: <ElectricRickshawIcon />,
      question: "Performance",
      tableData: [
        { feature: "Max torque", details: "45 Nm" },
        { feature: "Speed", details: "53 km/h" },
        { feature: "Tyres", details: "3" },
        { feature: "Range", details: "120 kms" },
        { feature: "Load Capacity", details: "550 kgs" },
        { feature: "GVW", details: "950 kgs" },
      ],
    },
    {
      id: 2,
      icon: <SquareFootIcon />,
      question: "Dimensions",
      tableData: [
        { feature: "Length", details: "10.78 ft" },
        { feature: "Width", details: "5.00 ft" },
        { feature: "Height", details: "7.30 ft" },
        { feature: "Wheelbase", details: "7.02 ft" },
        { feature: "Ground clearance", details: "0.72 ft" },
      ],
    },
    {
      id: 3,
      icon: <WorkspacePremiumRoundedIcon />,
      question: "Brakes & Suspensions",
      tableData: [
        { feature: "Brakes", details: "Hydraulic | Single Pedal Actuation" },
        {
          feature: "Front suspension",
          details: "Helical Spring + Damper + Hydraulic Shock Absorber",
        },
        { feature: "Rear suspension", details: "Rigid Axle with Leaf Spring" },
        { feature: "Parking brake type", details: "Mechanical lever" },
      ],
    },
    {
      id: 4,
      icon: <BuildCircleIcon />,
      question: "Charging",
      tableData: [
        { feature: "Charging time", details: "3.5 hours" },
        { feature: "Battery capacity", details: "11 kWh" },
        { feature: "Type of battery", details: "Li-ion Battery" },
      ],
    },
    {
      id: 5,
      icon: <LocalShippingIcon />,
      question: "Body",
      tableData: [
        { feature: "Chassis type", details: "Chassis with Cabin" },
        { feature: "Body option", details: "High Deck, Low Deck" },
        { feature: "Cabin type", details: "Day cabin" },
      ],
    },
    {
      id: 6,
      icon: <ManageAccountsIcon />,
      question: "Features",
      tableData: [
        { feature: "GPS", details: "Yes" },
        { feature: "Vehicle Tracking System", details: "Yes" },
        { feature: "Seating Capacity", details: "Driver Only" },
        { feature: "Gradeability", details: "18%" },
        { feature: "Driver information display", details: "Yes" },
      ],
    },
  ],
  montraePV: [
    {
      id: 1,
      icon: <ElectricRickshawIcon />,
      question: "Structure",
      tableData: [
        { feature: "Vehicle Category", details: "L5M" },
        { feature: "Seating Capacity", details: "D+3" },
        { feature: "Body Type", details: "Metal" },
        { feature: "Roof Type ", details: "Rexin canopy" },
        { feature: "Chassis ", details: "Sturdy boron steel chassis" },
      ],
    },
    {
      id: 2,
      icon: <SquareFootIcon />,
      question: "Dimensions & Weight",
      tableData: [
        { feature: "Dimensions - L X W X H", details: "2825 mm X 1350 mm X 1750 mm" },
        { feature: "Wheel Base", details: "2010 mm" },
        { feature: "Min Ground Clearance", details: "207 mm" },
        { feature: "Turning Circle Dia", details: "5248 mm" },
        { feature: "GVW", details: "756 kg" },
        { feature: "Kerb Weight", details: "456 kgs" },


      ],
    },
    {
      id: 3,
      icon: <WorkspacePremiumRoundedIcon />,
      question: "Performance",
      tableData: [
        { feature: "Top Speed", details: "55 km/h" },
        {
          feature: "Pick Up (0-20 km/h)",
          details: "4 sec",
        },
        { feature: "Gradeability (%)", details: "21%" },
        { feature: "Certified Range", details: "197 km" },
        { feature: "Typical Driving Range", details: "160 +/- 5 km" },
        { feature: "Regenerative Braking", details: "Yes" },
        { feature: "Drive Modes", details: "Park Assist / Eco / Drive / Power / Reverse" },
      ],
    },
    {
      id: 4,
      icon: <OfflineBoltIcon />,
      question: "Drivetrain",
      tableData: [
        { feature: "Peak Power (kW)", details: "10 kW" },
        { feature: "Peak Torque (Nm)", details: "60 Nm" },
      ],
    },
    {
      id: 5,
      icon: <PowerIcon />,
      question: "Battery and Charging",
      tableData: [
        { feature: "Battery Type", details: "Lithium-ion / 48V" },
        { feature: "Battery Capacity", details: "10 kWh" },
        { feature: "Charger Type", details: "Off board" },
      ],
    },
    {
      id: 6,
      icon: <HealthAndSafetyIcon />,
      question: "Suspension and Safety",
      tableData: [
        { feature: "Head Lamps", details: "High power halogen lights" },
        { feature: "Tail Lamps", details: "Integrated stylish LED lights" },
        { feature: "Suspension - Front", details: "Double fork helical spring" },
        { feature: "Suspension - Rear", details: "Shock absorber with helical spring" },
        { feature: "Brakes - Front / Rear", details: "Hydraulic drum brake" },
        { feature: "Tyres", details: "3.75 x 12 E 66 4PR" },
      ],
    },
    {
      id: 7,
      icon: <LivingIcon />,
      question: "Comfort and Feature",
      tableData: [
        { feature: "Driver Seat", details: "High back rest, ergonomic dual tone seat" },
        { feature: "Instrument Cluster", details: "4.3 inch LCD" },
        { feature: "Glove Box", details: "Yes, with lock" },
        { feature: "Mobile Charging", details: "12V socket" },
        { feature: "Montra Driver App", details: "Yes" },
        { feature: "Passenger Seats", details: "Dual-tone seats with superior cushion" },
        { feature: "Luggage Space", details: "Rear luggage cabin with tailgate" },
      ],
    },
  ],
  piaggioEcityFx: [
    {
      id: 1,
      icon: <ElectricRickshawIcon />,
      question: "Structure",
      tableData: [
        { feature: "Vehicle Category", details: "L5M" },
        { feature: "Seating Capacity", details: "D+3" },
        { feature: "Body Type", details: "Metal" },
        { feature: "Roof Type ", details: "Soft roof" },
      ],
    },
    {
      id: 2,
      icon: <SquareFootIcon />,
      question: "Dimensions & Weight",
      tableData: [
        { feature: "Dimensions - L X W X H", details: "2700 mm X 1370 mm X 1725 mm" },
        { feature: "Wheel Base", details: "1920 mm" },
        { feature: "Min Ground Clearance", details: "163 mm" },
        { feature: "GVW", details: "713 kg" },
        { feature: "Kerb Weight", details: "413 kg" },


      ],
    },
    {
      id: 3,
      icon: <WorkspacePremiumRoundedIcon />,
      question: "Performance",
      tableData: [
        { feature: "Top Speed", details: "45 km/h" },
        { feature: "Gradeability (%)", details: "19%" },
        { feature: "Typical Driving Range", details: "110 +/- 5 km" },
        { feature: "Drive Modes", details: "Boost Mode" },
      ],
    },
    {
      id: 4,
      icon: <OfflineBoltIcon />,
      question: "Drivetrain",
      tableData: [
        { feature: "Peak Power (kW)", details: "5.44 kW @ 3500 rpm" },
        { feature: "Peak Torque (Nm)", details: "29 Nm" },
      ],
    },
    {
      id: 5,
      icon: <PowerIcon />,
      question: "Battery and Charging",
      tableData: [
        { feature: "Battery Type", details: "Lithium-ion / 48V" },
        { feature: "Battery Capacity", details: "7.5 kWh" },
        { feature: "Charger Type", details: "48 V / 3000 W Off-board charger" },
        { feature: "Charging Time", details: "3 hours 45 minutes" },
      ],
    },
    {
      id: 6,
      icon: <HealthAndSafetyIcon />,
      question: "Suspension and Safety",
      tableData: [
          { feature: "Suspension - Front", details: "Leading arm, constant rate coil spring with hydraulic dampener" },
          { feature: "Suspension - Rear", details: "Semi trailing arm, rubber spring with hydraulic dampener" },
          { feature: "Brakes - Front / Rear", details: "Drum brake hydraulically actuated  | Internal expanding shoe type" },
          { feature: "Tyres", details: "4.0 – 8'" },
          { feature: "Steering ", details: "Handlebar type" },
          { feature: "Transmission", details: "PT Gear with Differential (Integrant)" },
      ],
    },
    {
      id: 7,
      icon: <LivingIcon />,
      question: "Comfort and Feature",
      tableData: [
                { feature:"Seat Type", details:"Standard" },
                { feature:"Passenger Seats", details:"Dual-tone seats" },
                { feature:"Window type", details:"Transparent windows on both sides" },
      ],
    },
  ],
  bajajAutoRikshaw: [
    {
      id: 1,
      icon: <ElectricRickshawIcon />,
      question: "Structure",
      tableData: [
        { feature: "Vehicle Category", details: "L5M" },
        { feature: "Seating Capacity", details: "D+3" },
        { feature: "Body Type", details: "Metal" },
        { feature: "Roof Type ", details: "Soft roof" },
        { feature: "Chassis ", details: "Chassis with Cabin" },
      ],
    },
    {
      id: 2,
      icon: <WorkspacePremiumRoundedIcon />,
      question: "Performance",
      tableData: [
        { feature: "Top Speed", details: "45 km/h" },
        { feature: "Gradability (%)", details: "29% max" },
        { feature: "Range", details: "178 km" },
        { feature: "Drive Modes", details: "Boost Mode" },
      ],
    },
    {
      id: 3,
      icon: <OfflineBoltIcon />,
      question: "Drivetrain",
      tableData: [
        { feature: "Peak Power (kW)", details: "4.5 kW (Continuous)" },
        { feature: "Peak Torque (Nm)", details: "36 Nm" },
      ],
    },
    {
      id: 4,
      icon: <PowerIcon />,
      question: "Battery and Charging",
      tableData: [
        { feature: "Battery Type", details: "Lithium-ion" },
        { feature: "Battery Capacity", details: "8.9 kWh" },
        { feature: "Charging socket grid side", details: "3 Pin 16 Amp" },
        { feature: "Charging Time", details: "4 hrs 30 minutes<3 Hrs- 80%" },
        { feature: "Cable", details: "RCD cable protects from voltage fluctuation" }
      ],
    },
    {
      id: 5,
      icon: <HealthAndSafetyIcon />,
      question: "Suspension and Safety",
      tableData: [
        { feature: "Suspension - Front", details: "Single shock absorber with spring" },
        { feature: "Suspension - Rear", details: "Independent trailing arm with helical spring" },
        { feature: "Brakes - Front / Rear", details: "Regenerative braking system with sensing mechanism" },
        { feature: "Tyres", details: "120/80R12" },
        { feature: "Steering", details: "Handlebar type" },
        { feature: "Transmission", details: "2 speed automatic transmission" },
      ],
    },
    {
      id: 6,
      icon: <LivingIcon />,
      question: "Others",
      tableData: [
        { feature: "Seat Type", details: "Standard" },
        { feature: "Warranty", details: "60 Months / 120 000 km" },
        { feature: "Exterior colour", details: "White and blue" },
      ],
    },
  ],
  MahindraTreoPlus: [
    {
      id: 1,
      icon: <ElectricRickshawIcon />,
      question: "Structure",
      tableData: [
        { feature: "Vehicle Category", details: "L5M" },
        { feature: "Seating Capacity", details: "D+3" },
        { feature: "Roof Type ", details: "Rexin canopy/ Hardtop" },
      ],
    },
    {
      id: 2,
      icon: <SquareFootIcon />,
      question: "Dimensions & Weight",
      tableData: [
        { feature: "Dimensions - L X W X H", details: "2769 mm X 1350 mm X 1750 mm / 2769 mm X 1350 mm X 1757 mm" },
        { feature: "Wheel Base", details: "2073 mm" },
        { feature: "Min Ground Clearance", details: "142 mm" },
        { feature: "GVW", details: "701 kg / 713 kg" },
      ],
    },
    {
      id: 3,
      icon: <WorkspacePremiumRoundedIcon />,
      question: "Performance",
      tableData: [
        { feature: "Top Speed", details: "55 km/h" },
        { feature: "Gradability (%)", details: "12.45%" },
        { feature: "Certified Range", details: "167 km" },
        { feature: "Typical Driving Range", details: "150 km" },
        { feature: "Drive Modes", details: "Economy & Boost Mode" },
      ],
    },
    {
      id: 4,
      icon: <OfflineBoltIcon />,
      question: "Drivetrain",
      tableData: [
        { feature: "Peak Power (kW)", details: "8 kW" },
        { feature: "Peak Torque (Nm)", details: "42 Nm" },
      ],
    },
    {
      id: 5,
      icon: <PowerIcon />,
      question: "Battery and Charging",
      tableData: [
        { feature: "Battery Type", details: "Lithium-ion / 48V" },
        { feature: "Battery Capacity", details: "10.24 kWh" },
        { feature: "Charging Time", details: "4 hr 20 min" },
      ],
    },
    {
      id: 6,
      icon: <HealthAndSafetyIcon />,
      question: "Suspension and Safety",
      tableData: [
        { feature: "Suspension - Front", details: "Helical spring dampener hydraulic shock absorber" },
        { feature: "Suspension - Rear", details: "Rigid axle leaf spring" },
        { feature: "Brakes - Front / Rear", details: "Hydraulic drum brake" },
        { feature: "Parking Brakes", details: "Yes" },
      ],
    },
  ],
  ekaK15: [
    {
      id: 1,
      icon: <LocalShippingIcon />,
      question: "Structure",
      tableData: [
        { feature: "Vehicle Category", details: "L5M" },
        { feature: "Seating Capacity", details: "1+D" },
        { feature: "Roof Type ", details: "Rexin canopy/ Hardtop" },
      ],
    },
    {
      id: 2,
      icon: <SquareFootIcon />,
      question: "Dimensions & Weight",
      tableData: [
        { feature: "Dimensions - L X W X H", details: "4610 mm X 1600 mm X 1850 mm" },
        { feature: "Wheel Base", details: "2900 mm" },
        // { feature: "Min Ground Clearance", details: "142 mm" }
        { feature: "GVW", details: "2510 kg" },
      ],
    },
    {
      id: 3,
      icon: <WorkspacePremiumRoundedIcon />,
      question: "Performance",
      tableData: [
        { feature: "Top Speed", details: "70 km/h" },
        { feature: "Gradability (%)", details: "18%" },
        { feature: "Certified Range", details: "240 km" },
        { feature: "Typical Driving Range", details: "180 km" },
        { feature: "Drive Modes", details: "Economy & Boost Mode" },
      ],
    },
    {
      id: 4,
      icon: <OfflineBoltIcon />,
      question: "Drivetrain",
      tableData: [
        { feature: "Peak Power (kW)", details: "8 kW" },
        { feature: "Peak Torque (Nm)", details: "42 Nm" },
      ],
    },
    {
      id: 5,
      icon: <PowerIcon />,
      question: "Battery and Charging",
      tableData: [
        { feature: "Battery Type", details: "Lithium-ion / 48V" },
        { feature: "Battery Capacity", details: "32 kWh" },
        { feature: "Charging Time", details: "4 hr" },
      ],
    },
    {
      id: 6,
      icon: <HealthAndSafetyIcon />,
      question: "Suspension and Safety",
      tableData: [
        { feature: "Suspension - Front", details: "Helical spring dampener hydraulic shock absorber" },
        { feature: "Suspension - Rear", details: "Rigid axle leaf spring" },
        { feature: "Brakes - Front / Rear", details: "Hydraulic drum brake" },
        { feature: "Parking Brakes", details: "Yes" },
      ],
    },
  ]
};
